import { defineStore } from 'pinia'
import { ref } from "vue";
import { request } from "@/ts/request";
import { RequestStatus } from "@/ts/interfaces/requests/statusEnum"

const basePathName = '/api/skill'

const routes = {
    'index': '/plucked',
}

export const useSkillsStore = defineStore('skills',  () => {
    const skills = ref<object>([])

    const status = ref<RequestStatus | null >(RequestStatus.INITIAL)

    async function listSkills() {
        status.value = RequestStatus.LOADING

        const response = await request(`${basePathName}${routes.index}`, {
            method: 'GET'
        })

        if(response.ok) {
            status.value = RequestStatus.SUCCESS
            skills.value = await response.json()
        }
    }

    return { skills, status, listSkills }
})